
(function() {
  var result = { translations: { "es": { "i18n": { "duration": { "seconds": "{{ seconds }} s", "minutes": "{{ minutes }} min", "hours": "{{ hours }} h", "hoursAndMinutes": "{{ hours }} h {{ minutes }} min", "days": "{{ days }} d\xEDas", "shortForm": { "seconds": "{{ seconds }} s", "minutes": "{{ minutes }} m", "hours": "{{ hours }} h", "days": "{{ days }} d", "hoursAndMinutes": "{{ hours }} h {{ minutes }} min" } }, "dateTime": { "quarterAndYear": "T{{quarterNumber}} {{yearNumber}}" }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": "{{currencyCode}} {{amountNumberValue}}", "phoneNumberWithExtension": "{{phoneNumber}}, ext. {{extension}}" } } } } };
  result.translationsLoaded = {
  "I18n": {
    "es": "static-7.1340"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "af": "static-7.1340",
    "ar-eg": "static-7.1340",
    "bg": "static-7.1340",
    "bn": "static-7.1340",
    "ca-es": "static-7.1340",
    "cs": "static-7.1340",
    "da": "static-7.1340",
    "de": "static-7.1340",
    "el": "static-7.1340",
    "en-gb": "static-7.1340",
    "en": "static-7.1340",
    "es-mx": "static-7.1340",
    "es": "static-7.1340",
    "et": "static-7.1340",
    "fi": "static-7.1340",
    "fr-ca": "static-7.1340",
    "fr": "static-7.1340",
    "he-il": "static-7.1340",
    "hi": "static-7.1340",
    "hr": "static-7.1340",
    "hu": "static-7.1340",
    "id": "static-7.1340",
    "it": "static-7.1340",
    "ja": "static-7.1340",
    "ko": "static-7.1340",
    "lt": "static-7.1340",
    "ms": "static-7.1340",
    "nl": "static-7.1340",
    "no": "static-7.1340",
    "pl": "static-7.1340",
    "pt-br": "static-7.1340",
    "pt-pt": "static-7.1340",
    "ro": "static-7.1340",
    "ru": "static-7.1340",
    "sk": "static-7.1340",
    "sl": "static-7.1340",
    "sv": "static-7.1340",
    "th": "static-7.1340",
    "tl": "static-7.1340",
    "tr": "static-7.1340",
    "uk": "static-7.1340",
    "vi": "static-7.1340",
    "x-pseudo": "static-7.1340",
    "zh-cn": "static-7.1340",
    "zh-hk": "static-7.1340",
    "zh-tw": "static-7.1340"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:es', {version: 'static-7.1340'}); }
})();


